import Immutable from 'immutable';
import { defaultCommunicationObject, updateCommunicationObject } from '~client/reducers/shared';
import { bookingsActionTypes } from '~constants/actionTypes';

export const defaultState = Immutable.fromJS({
  properties: {
    communication: defaultCommunicationObject,
    payload: [],
  },

  listings: {
    communication: defaultCommunicationObject,
    payload: [],
    totalCount: 0,
    totalPages: 1,
  },

  summary: {
    communication: defaultCommunicationObject,
    payload: {},
  },

  order: {
    communication: defaultCommunicationObject,
    payload: {},
  },

  confirmCommunication: defaultCommunicationObject,
  rejectCommunication: defaultCommunicationObject,
  commentCommunication: defaultCommunicationObject,
  updateBookingStatusCommunication: defaultCommunicationObject,
  exportListCommunication: defaultCommunicationObject,
  batchUpdateBookingStatusCommunication: defaultCommunicationObject,
});

const formatPropertiesPayload = properties =>
  properties.map(property => ({
    id: property.node.id,
    name: property.node.name,
    currency: property.node.currency,
  }));

const bookingsReducer = (state = defaultState, action) => {
  switch (action.type) {
    case bookingsActionTypes.SET_BOOKINGS_PROPERTIES_LIST: {
      const nextState = state.deleteIn(['properties', 'payload']);
      return nextState.mergeDeep({
        properties: {
          payload: formatPropertiesPayload(action.payload.viewer.company.properties.edges),
        },
      });
    }

    case bookingsActionTypes.GET_BOOKINGS_PROPERTIES_LIST_CS:
      return state.mergeDeep({
        properties: {
          communication: updateCommunicationObject(action.status, action.error),
        },
      });

    case bookingsActionTypes.SET_BOOKINGS_LIST: {
      const nextState = state.deleteIn(['listings', 'payload']);
      return nextState.mergeDeep({
        listings: {
          payload: action.payload.viewer.company.bookings.edges,
          totalCount: action.payload.viewer.company.bookings.totalCount,
          totalPages: action.payload.viewer.company.bookings.pageInfo.numPages,
        },
      });
    }

    case bookingsActionTypes.GET_BOOKINGS_LIST_CS:
      return state.mergeDeep({
        listings: {
          communication: updateCommunicationObject(action.status, action.error),
        },
      });

    case bookingsActionTypes.SET_BOOKINGS_SUMMARY: {
      const nextState = state.deleteIn(['summary', 'payload']);
      return nextState.mergeDeep({
        summary: {
          payload: action.payload.viewer.company.summary
            ? { ...action.payload.viewer.company.summary }
            : { ...action.payload.viewer.company.bookings },
        },
      });
    }

    case bookingsActionTypes.GET_BOOKINGS_SUMMARY_CS:
      return state.mergeDeep({
        summary: {
          communication: updateCommunicationObject(action.status, action.error),
        },
      });

    case bookingsActionTypes.UPDATE_BOOKINGS_CONFIRM_CS:
      return state.mergeDeep({
        confirmCommunication: updateCommunicationObject(action.status, action.error),
      });

    case bookingsActionTypes.SET_BOOKINGS_REJECT_CS:
      return state.mergeDeep({
        rejectCommunication: updateCommunicationObject(action.status, action.error),
      });

    case bookingsActionTypes.CREATE_BOOKING_COMMENT_CS:
      return state.mergeDeep({
        commentCommunication: updateCommunicationObject(action.status, action.error),
      });

    case bookingsActionTypes.UPDATE_BOOKING_STATUS_CS:
      return state.mergeDeep({
        updateBookingStatusCommunication: updateCommunicationObject(action.status, action.error),
      });

    case bookingsActionTypes.EXPORT_LIST_CS:
      return state.mergeDeep({
        exportListCommunication: updateCommunicationObject(action.status, action.error),
      });

    case bookingsActionTypes.BATCH_UPDATE_BOOKING_STATUS_CS:
      return state.mergeDeep({
        batchUpdateBookingStatusCommunication: updateCommunicationObject(
          action.status,
          action.error,
        ),
      });

    case bookingsActionTypes.GET_LONGTAIL_BOOKING_CS:
      return state.mergeDeep({
        order: {
          communication: updateCommunicationObject(action.status, action.error),
        },
      });

    case bookingsActionTypes.SET_LONGTAIL_BOOKING: {
      const nextState = state.deleteIn(['order', 'payload']);
      return nextState.mergeDeep({
        order: {
          payload:
            action.payload &&
            action.payload.viewer &&
            action.payload.viewer.company &&
            action.payload.viewer.company.orders &&
            action.payload.viewer.company.orders.edges &&
            action.payload.viewer.company.orders.edges[0] &&
            action.payload.viewer.company.orders.edges[0].node
              ? { ...action.payload.viewer.company.orders.edges[0].node }
              : {},
        },
      });
    }

    default:
      return state;
  }
};

export default bookingsReducer;
